import { useSelector } from 'react-redux';

type Tenant = undefined | 'OP' | 'OpenDr';

export const useTenant = (): Tenant => {
  const { currentPractitionerEntitlements } = useSelector(
    (state: any) => state?.practitionerState
  );
  const tenant: Tenant = currentPractitionerEntitlements?.plans?.find(
    (plan: { metadata: any }) => plan?.metadata?.tenant
  )?.metadata?.tenant;
  return tenant;
};

export const useIsOP = (): boolean => {
  const tenant = useTenant();
  return tenant === 'OP';
};

export const useIsOpenDr = (): boolean => {
  const tenant = useTenant();
  return tenant === 'OpenDr';
};
